module.exports = __webpack_public_path__ + "static/media/Lilac.c6125390.png";